import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classifyTaxId, formatIban, formatPlate, isValidTrIban, isValidTrPlate, normalizeIban, normalizePlate, } from "@station/core";
import { CircleCheck } from "lucide-react";
import { useState } from "react";
import { Input } from "../components/form.js";
import { cn } from "../lib/cn.js";
function ValidMark({ label }) {
    return (_jsxs("span", { className: "pointer-events-none absolute inset-y-0 right-3 flex items-center gap-1 text-xs font-medium text-success", children: [_jsx(CircleCheck, { className: "size-4", "aria-hidden": "true" }), label] }));
}
/** VKN (10 hane) / TCKN (11 hane): yalnızca rakam kabul eder, kontrol hanesini doğrular, türü gösterir. */
export function TaxIdInput({ value, onValueChange, onValidityChange, className, onBlur, ...props }) {
    const [touched, setTouched] = useState(false);
    const kind = classifyTaxId(value);
    const invalid = touched && value !== "" && !kind;
    return (_jsxs("div", { className: "relative", children: [_jsx(Input, { ...props, inputMode: "numeric", autoComplete: "off", maxLength: 11, value: value, "aria-invalid": invalid || props["aria-invalid"], className: cn("tabular pr-16", className), onChange: (event) => onValueChange(event.target.value.replace(/\D/g, "").slice(0, 11)), onBlur: (event) => {
                    setTouched(true);
                    onValidityChange?.(value === "" || kind
                        ? null
                        : value.length === 11
                            ? "Geçersiz T.C. kimlik numarası"
                            : "Geçersiz vergi kimlik numarası");
                    onBlur?.(event);
                } }), kind ? _jsx(ValidMark, { label: kind }) : null] }));
}
/** TR IBAN: dörtlü gruplar hâlinde gösterir, mod 97 ile doğrular. Dışarıya boşluksuz değer verir. */
export function IbanInput({ value, onValueChange, onValidityChange, className, onBlur, ...props }) {
    const [touched, setTouched] = useState(false);
    const valid = value !== "" && isValidTrIban(value);
    return (_jsxs("div", { className: "relative", children: [_jsx(Input, { ...props, autoComplete: "off", spellCheck: false, placeholder: props.placeholder ?? "TR00 0000 0000 0000 0000 0000 00", value: formatIban(value), "aria-invalid": (touched && value !== "" && !valid) || props["aria-invalid"], className: cn("font-mono tabular pr-10 uppercase", className), onChange: (event) => onValueChange(normalizeIban(event.target.value)
                    .replace(/[^A-Z0-9]/g, "")
                    .slice(0, 26)), onBlur: (event) => {
                    setTouched(true);
                    onValidityChange?.(value === "" || valid ? null : "Geçersiz IBAN");
                    onBlur?.(event);
                } }), valid ? _jsx(ValidMark, { label: "" }) : null] }));
}
/** Türkiye plakası: büyük harfe çevirir, "34 ABC 123" biçiminde gösterir. Dışarıya boşluksuz değer verir. */
export function PlateInput({ value, onValueChange, onValidityChange, className, onBlur, ...props }) {
    const [touched, setTouched] = useState(false);
    const [focused, setFocused] = useState(false);
    const valid = value !== "" && isValidTrPlate(value);
    return (_jsx(Input, { ...props, autoComplete: "off", spellCheck: false, placeholder: props.placeholder ?? "34 ABC 123", value: focused ? value : formatPlate(value), "aria-invalid": (touched && value !== "" && !valid) || props["aria-invalid"], className: cn("font-mono uppercase tracking-wide", className), onFocus: () => setFocused(true), onChange: (event) => onValueChange(normalizePlate(event.target.value)
            .replace(/[^A-Z0-9]/g, "")
            .slice(0, 9)), onBlur: (event) => {
            setFocused(false);
            setTouched(true);
            onValidityChange?.(value === "" || valid ? null : "Geçersiz plaka (ör. 34 ABC 123)");
            onBlur?.(event);
        } }));
}
//# sourceMappingURL=identity-inputs.js.map